import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	description: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		marginBottom: THEME.spacing.md,
	},
	selectedList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.md,
	},
	selectedItem: {
		alignItems: 'center',
		background: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		justifyContent: 'space-between',
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
	},
	selectedItemDetails: {
		display: 'flex',
		flexDirection: 'column',
		minWidth: 0,
	},
	selectedItemName: {
		...THEME.common.truncate,
		fontSize: THEME.typography.fontSizes.sm,
	},
	selectedItemEmail: {
		...THEME.common.truncate,
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	limitHint: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.sm,
	},
});
